import React from 'react';
import styled from 'styled-components';
import { breakpointsMinWidth } from '../../../../../../../common/styling';

const SVG = styled.svg`
  width: 40px;
  height: 40px;
  @media ${breakpointsMinWidth.tabletSm} {
    width: 64px;
    height: 64px;
  }
`;

export const LeftButton = () => (
  <SVG
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
  >
    <g clipPath="url(#clip0_2116_662)">
      <path
        d="M41.0078 44.24L28.8199 32L41.0078 19.76L37.2556 16L21.2889 32L37.2556 48L41.0078 44.24Z"
        fill="#DCDCDC"
      />
    </g>
    <defs>
      <clipPath id="clip0_2116_662">
        <rect
          width="64"
          height="63.8669"
          fill="white"
          transform="translate(63.8669) rotate(90)"
        />
      </clipPath>
    </defs>
  </SVG>
);

export const RightButton = () => (
  <SVG
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
  >
    <g clipPath="url(#clip0_2116_659)">
      <path
        d="M22.8591 19.76L35.0471 32L22.8591 44.24L26.6113 48L42.578 32L26.6113 16L22.8591 19.76Z"
        fill="#DCDCDC"
      />
    </g>
    <defs>
      <clipPath id="clip0_2116_659">
        <rect
          width="64"
          height="63.8669"
          fill="white"
          transform="translate(0 64) rotate(-90)"
        />
      </clipPath>
    </defs>
  </SVG>
);
